import { AbstractConfDataCommand } from "./abstractConfDataCommand";

export class StateCommand extends AbstractConfDataCommand {
  promoteInfo?: boolean;
  demoteInfo?: boolean;
  setPromoteStateId?: number;
  setDemoteStateId?: number;
  note?: string;
}